import { render, staticRenderFns } from "./ForSaleDetails.vue?vue&type=template&id=103745b1&"
import script from "./ForSaleDetails.vue?vue&type=script&lang=js&"
export * from "./ForSaleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports